import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/new-getqcall/htdocs/new.getqcall.com/getQCall/components/ScrollFadeIn.js");
;
import(/* webpackMode: "eager" */ "/home/new-getqcall/htdocs/new.getqcall.com/getQCall/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/new-getqcall/htdocs/new.getqcall.com/getQCall/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/new-getqcall/htdocs/new.getqcall.com/getQCall/public/images/solutuin.jpg");
